import { Link } from "react-router-dom";
import type { HotComment } from "@/types/news";
import { getArticleById } from "@/utils/articles";

interface CommentFeedProps {
  comments: HotComment[];
}

const avatarTones = [
  "bg-primary-100 text-primary-800",
  "bg-accent-100 text-accent-900",
  "bg-secondary-200 text-secondary-900",
  "bg-background-200 text-foreground-700",
];

export default function CommentFeed({ comments }: CommentFeedProps) {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
      <div className="flex items-center justify-between px-4 md:px-5 h-14 border-b border-background-200">
        <div className="flex items-center gap-2">
          <span className="w-5 h-5 flex items-center justify-center text-primary-600">
            <i className="ri-chat-smile-2-line text-lg" aria-hidden="true" />
          </span>
          <h2 className="font-heading text-base font-bold text-foreground-950">最新评论动态</h2>
        </div>
        <span className="inline-flex items-center gap-1 text-[11px] text-foreground-400">
          <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-soft-pulse" />
          实时
        </span>
      </div>

      <ul className="px-4 md:px-5 py-2">
        {comments.map((comment, index) => {
          const article = getArticleById(comment.articleId);
          return (
            <li key={comment.id} className="py-3 border-b border-background-100 last:border-b-0">
              <div className="flex items-start gap-2.5">
                <span
                  className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-xs font-medium ${
                    avatarTones[index % avatarTones.length]
                  }`}
                >
                  {comment.user.slice(0, 1)}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center justify-between gap-2">
                    <span className="text-xs font-medium text-foreground-800 truncate">
                      {comment.user}
                    </span>
                    <span className="shrink-0 text-[10px] text-foreground-400">{comment.time}</span>
                  </div>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-700 line-clamp-2">
                    {comment.text}
                  </p>
                  {article && (
                    <Link
                      to={`/detail/${article.id}`}
                      className="mt-1.5 inline-flex items-center gap-1 text-[11px] text-primary-700 hover:text-primary-600 transition-colors max-w-full cursor-pointer"
                    >
                      <span className="w-3 h-3 flex items-center justify-center shrink-0">
                        <i className="ri-link" aria-hidden="true" />
                      </span>
                      <span className="truncate">{article.title}</span>
                    </Link>
                  )}
                </div>
              </div>
            </li>
          );
        })}
      </ul>
      <p className="px-4 md:px-5 py-3 border-t border-background-200 text-[11px] text-foreground-400 bg-background-100/60">
        评论为演示数据，暂未开放真实互动
      </p>
    </section>
  );
}